import React from 'react';
import { Row, Col } from 'antd';
import RadioType from '../../RevisionPage/components/answerTypes/RadioType';
import SelectType from '../../RevisionPage/components/answerTypes/SelectType';
import TextAreaType from '../../RevisionPage/components/answerTypes/TextAreaType';
import DateType from '../../RevisionPage/components/answerTypes/DateType';

const EditAnswer = ({
  answer,
  onEdit
}) => {

  return (
    <Row className="question-container mt-80">
      {answer && (
        <Col lg={22} md={22}>
          {answer.input_type === 'radio' && answer.questionOptions && <RadioType question={answer} onEdit={onEdit} />}
          {['select', 'select_multiple'].includes(answer.input_type) && answer.questionOptions && <SelectType question={answer} onEdit={onEdit} isMultiple={true}/>}
          {(answer.input_type === 'textArea' || answer.input_type === 'text') && <TextAreaType question={answer} onEdit={onEdit} />}
          {answer.input_type === 'date' && answer.questionOptions && <DateType question={answer} onEdit={onEdit} />}
        </Col>
      )}
    </Row>
  );
};

export default EditAnswer;